<template>
  <div>
    <FormKit
      type="form"
      @submit="submitHandlerUpdate"
      :actions="false"
      #default="{ value }"
      :value="true"
      allow-incomplete="true"
    >
      <FormKit type="multi-step" name="multi-step_2"  id="multi-step_2" tab-style="tab" >
        <FormKit type="step" name="Informations" :previousLabel="'Précédent'"  :nextLabel="'Suivant'">
          <Step2Edit/>
        </FormKit>
        <FormKit type="step" name="categories" :previousLabel="'Précédent'"  :nextLabel="'Suivant'">
          <Step3Edit />
        </FormKit>
        <FormKit type="step" label= "Images & Descriptions" name="ImagesAndDescriptions" :previousLabel="'Précédent'" :nextLabel="'Suivant'">
          <Step4Edit :descriptions="descriptions" :images="images" ref="stepFour" />
          <template #stepNext>
            <FormKit type="submit" label="Modifier" />
          </template>
        </FormKit>
      </FormKit>
    </FormKit>
  </div>
</template>

<script setup lang="ts">

import Step2Edit from '@/components/product/masterProduct/update/UpdateInformationStep.vue'
import Step3Edit from "@/components/product/masterProduct/update/UpdateCategoriesStep.vue";
import Step4Edit from '@/components/product/masterProduct/update/UpdateDescriptionImageStep.vue'
import { ref, reactive, computed } from 'vue'
import ApiService from "@/_services/api.service";
import Swal from "@/_helpers/swal";
import { getNode } from '@formkit/core';
import router from "@/router";
import { useRoute } from 'vue-router'
import { onMounted , onBeforeMount } from 'vue'
const descriptions = reactive([]);
const images = reactive([]);
const stepFour = ref();
let selectedPrototype = ref();
const submitted = ref(false)
let productData = ref()
import {PRODUCT_PROTOTYPES} from "@/constants/product/properties";
import {getCountryNameByCode} from "@/_services/geolocation/country";

const submitHandlerUpdate = async (data) => {
  try {
    const productUuid = route.params.uuid;
    const payload = generateCommonPayload(data);
    delete data['multi-step_2']['categories']["hasSelectedCategory"]

    if (selectedPrototype.value === PRODUCT_PROTOTYPES.TICKET) {
      await submitETicket(productUuid, payload);
      Swal.success('', 'Vous venez de modifier un produit E-billet');
    }
    else if (selectedPrototype.value === PRODUCT_PROTOTYPES.PHYSICAL) {
      await updatePhysicalProduct( productUuid, payload);
      Swal.success('', 'Vous venez de modifier un produit physique');
    } else if (selectedPrototype.value === PRODUCT_PROTOTYPES.GIFT) {
      await submitGiftCard( productUuid, payload);
      Swal.success('', 'Vous venez de modifier un produit carte cadeau');
    } else if (selectedPrototype.value === PRODUCT_PROTOTYPES.PROMO) {
      await submitPromotionCode( productUuid, payload);
      Swal.success('', 'Vous venez de modifier une Redirection sur site partenaire / Codes promo');
    } else if (selectedPrototype.value === PRODUCT_PROTOTYPES.MEMBER) {
      await submitProductMember(productUuid, payload);
      Swal.success('', 'Vous venez de modifier une carte de membre');
    }
    await router.push({ name: 'ListProducts' });
  } catch (error) {
    console.error(error)
    Swal.error('An error occurred catch');
  }
  await new Promise((r) => setTimeout(r, 1000));
  submitted.value = true;
};

const generateCommonPayload = (data) => {
  let reductionTypeToSend = '';
  let publicPrice = null;
  if(
    selectedPrototype.value !== PRODUCT_PROTOTYPES.PROMO &&
    selectedPrototype.value !== PRODUCT_PROTOTYPES.MEMBER ) {
    reductionTypeToSend =  data['multi-step_2']['Informations']['reductionTypeAsReduction'];
    publicPrice =  parseFloat(data['multi-step_2']['Informations']['publicPrice']);
  }else {
    reductionTypeToSend =  data['multi-step_2']['Informations']['reductionType'];
  }

  let payload =  {
    prototype: selectedPrototype.value,
    mainInformationsBlock: {
      reference: data['multi-step_2']['Informations']['reference'],
      brand: {
        name: data['multi-step_2']['Informations']['brand']['name'],
        uuid: data['multi-step_2']['Informations']['brand']['uuid'],
      },
      productName: data['multi-step_2']['Informations']['productName'],
      adminProductName: data['multi-step_2']['Informations']['adminProductName'],
      shortDescription: data['multi-step_2']['Informations']['shortDescription']?? '',
      urssafClassification: [data['multi-step_2']['Informations']['urssafClassification']],
      urssafEvent: data['multi-step_2']['Informations']['urssafEvent'],
      socialEvent: data['multi-step_2']['Informations']['socialEvent'],
    },
    statusBlock: {
      status: data['multi-step_2']['Informations']['statusBlock'],
      activationDate: data['multi-step_2']['Informations']['enableDate'],
      disabledDate: data['multi-step_2']['Informations']['disabledDate'],
      saleClosingReason: data['multi-step_2']['Informations']['saleClosingReason'],
      active: data['multi-step_2']['Informations']['active'] ? 1 : 0,
      hiddenProduct: data['multi-step_2']['Informations']['hiddenProduct'] ? 1 : 0,
      closedSale: data['multi-step_2']['Informations']['closedSale'] ? 1 : 0,
    },
    redirectionLink: data['multi-step_2']['Informations']['redirectionLink'],
    descriptions: data['multi-step_2']['ImagesAndDescriptions']['descriptionListUuid'],
    images: getImagesUuid(data['multi-step_2']['ImagesAndDescriptions']['images']),
    categories: data['multi-step_2']['categories']["hasSelectedCategory"],
    specialProperty: data['multi-step_2']['Informations']['specialProperty'],
    supplierBlock: {
      supplier: data['multi-step_2']['Informations']['supplier'],
      shippingMethod: data['multi-step_2']['Informations']['shippingMethod'],
      delayedSending: data['multi-step_2']['Informations']['delayedSending'],
    },
    stockBlock: {
      stock: parseInt(data['multi-step_2']['Informations']['stock']),
      limitByCart: parseInt(data['multi-step_2']['Informations']['limitByCart']),
      limitByUser: parseInt(data['multi-step_2']['Informations']['limitByUser']),
      stockAlertThreshold: parseInt(data['multi-step_2']['Informations']['stockAlertThreshold']),
    },
    pricingBlock: {
      price: parseFloat(data['multi-step_2']['Informations']['price']),
      tax: data['multi-step_2']['Informations']['tax'],
      reductionType: reductionTypeToSend,
      publicPrice: publicPrice,
      reductionValue:  data['multi-step_2']['Informations']['reductionValue'],
      reductionDescription:  data['multi-step_2']['Informations']['reductionDescription'],
      purchasingPrice: parseFloat(data['multi-step_2']['Informations']['purchasingPrice']),
      country: 'FR',
    },
    usageConditionBlock: {
      onlineValidity: data['multi-step_2']['Informations']['usableOnline'],
      offlineValidity: data['multi-step_2']['Informations']['usableInStore'],
      driveValidity: data['multi-step_2']['Informations']['usableInDrive'],
    },
    promotionCodeBlock: {
      webPromoCode: data['multi-step_2']['Informations']['webPromoCode'],
      phonePromoCode: data['multi-step_2']['Informations']['codePromoPhone'],
      phoneNumber: data['multi-step_2']['Informations']['phone'],
      callPrice: data['multi-step_2']['Informations']['callPrice']
    },
    promotionIdentificationBlock: {
      login: data['multi-step_2']['Informations']['identifiant'],
      password: data['multi-step_2']['Informations']['password'],
    },
    geolocations: prepareGeolocation(data)
  }
  if (payload.pricingBlock.publicPrice == null ) {
    delete payload.pricingBlock.publicPrice;
  }

  if (payload.statusBlock.activationDate === null) {
    delete payload.statusBlock.activationDate;
  }
  if (payload.statusBlock.saleClosingReason === null) {
    delete payload.statusBlock.saleClosingReason;
  }

  if (payload.mainInformationsBlock.shortDescription === null) {
    delete payload.statusBlock.saleClosingReason;
  }
  return payload;
}

const updatePhysicalProduct = async (productUuid, payload) => {
  await ApiService.patch('master-product-physical', productUuid.toString() ,payload);
}
const submitETicket = async (productUuid, payload) => {
  await ApiService.patch('master-product-e-ticket', productUuid.toString() ,payload);
}

const submitGiftCard = async (productUuid, payload) => {
  await ApiService.patch('master-product-gift-card', productUuid.toString() ,payload);
}

const submitProductMember = async (productUuid, payload) => {
  await ApiService.patch('master-product-member-card', productUuid.toString() ,payload);
};

const submitPromotionCode = async (productUuid, payload) => {
  await ApiService.patch('master-product-promotion-code', productUuid.toString() ,payload);
};

function prepareGeolocation(data) {
  let geolocations: any = [];
  const type = data['multi-step_2']['Informations']['geolocationType'];
  const apiKey = data['multi-step_2']['Informations']['geolocationApiKey'];
  const addresses: any = data['multi-step_2']['Informations']['geolocationAddresses'];
  if (apiKey) {
    geolocations.push({
      type: type,
      apiKey: apiKey
    })
  } else if ( addresses?.length) {
    addresses.forEach((address) => {
        let dataGeolocation = {
            type: type,
            method: address.manualMethod
        };
        
        if ('address' === address.manualMethod || 'completed_by_partner' === address.manualMethod) {
            const countryCode = address.country;
            const countryName = getCountryNameByCode(countryCode);
            
            dataGeolocation.address = address.address;
            dataGeolocation.zipCode = address.zipCode;
            dataGeolocation.city = address.city;
            dataGeolocation.country = countryName;
            dataGeolocation.countryCode = countryCode;
        }
        
        if ('geocoding' === address.manualMethod || 'completed_by_partner' === address.manualMethod) {
            dataGeolocation.longitude = parseFloat(address.longitude);
            dataGeolocation.latitude = parseFloat(address.latitude);
        }
        
        if ('completed_by_partner' === address.manualMethod) {
            dataGeolocation.formattedAddress = address.formattedAddress;
        }
        
      geolocations.push(dataGeolocation);
    });
  } else {
    geolocations.push({
      type: type,
    })
  }
  return geolocations;
}
function getImagesUuid(imagesArray) {
  const imagesUuids = imagesArray.reduce((accumulator, image) => {
    if (image.uuid) {
      accumulator.push(image.uuid);
    }
    return accumulator;
  }, []);
  return imagesUuids;
}

const route = useRoute();

const getProductData = async (productUuid) => {

  try {
    const response = await ApiService.get("/master-product/" + productUuid);

    productData.value = response.data.data;
    let productName: string;
    let status : string;
    let closedSale : boolean;
    //let hiddenProduct  : boolean;
    let reference: string;
    let adminProductName : string;
    let shortDescription : string;
    let saleClosingReason :string;
    let urssafEvent :any[] = [];
    let urssafEventValues: any[] = [];
    let socialEvent :any[] = [];
    let socialEventValues: any[] = [];
    let activationDate : string;
    let disabledDate : string;
    let redirectionLink : string;
    let password : string;
    let identifiant : string;
    let webPromoCode : string;
    let phone : string;
    let codePromoPhone : string;
    let callPrice : number;
    let delayedSending : string;
    let delayedSendingFront : boolean;
    let offlineValidity :string;
    let offlineValidityFront :boolean;
    let onlineValidity : string;
    let driveValidity;
    let onlineValidityFront :boolean;
    let driveValidityFront : boolean;
    let urssafClassification: string;


    productName = response.data.data.properties.productName[0]?.value;
    redirectionLink = response.data.data.properties.redirectionLink[0]?.value;
    reference = response.data.data.properties.reference[0]?.value ;
    adminProductName = response.data.data.properties.adminProductName[0]?.value ;
    shortDescription = response.data.data.properties.shortDescription[0]?.value ;
    saleClosingReason = response.data.data.properties.saleClosingReason[0]?.value ;
    closedSale = response.data.data.status.closedSale  ;
    activationDate = response.data.data.properties.activationDate[0]?.value ;
    disabledDate = response.data.data.properties.disabledDate[0]?.value ;
    password = response.data.data.properties.password[0]?.value ;
    identifiant = response.data.data.properties.identifiant[0]?.value ;
    webPromoCode = response.data.data.properties.webPromoCode[0]?.value ;
    phone = response.data.data.properties.phoneNumber[0]?.value ;
    codePromoPhone = response.data.data.properties.phonePromoCode[0]?.value ;
    callPrice = response.data.data.properties.callPrice[0]?.value ;

    for (const item of response.data.data.properties.urssafEvent) {
      urssafEventValues.push(item.uuid)
    }
    urssafEvent = urssafEventValues
      
    urssafClassification = response.data.data.properties.urssafClassification[0]?.uuid;
    
      for (const item of response.data.data.socialEvent) {
          socialEventValues.push(item.value);
      }
      socialEvent = socialEventValues;
      delayedSending = response.data.data.properties.delayedSending[0]?.value ;
    if(delayedSending == "1"){
      delayedSendingFront = true;
    }

    offlineValidity = response.data.data.properties.offlineValidity ? response.data.data.properties.offlineValidity[0]?.value : false;

    if(offlineValidity == "1"){
      offlineValidityFront = true;
    }
    onlineValidity = response.data.data.properties.onlineValidity ? response.data.data.properties.onlineValidity[0]?.value : false ;
    if(onlineValidity == "1"){
      onlineValidityFront = true;
    }
    driveValidity = response.data.data.properties.driveValidity ? response.data.data.properties.driveValidity[0]?.value : null ;
    switch (driveValidity) {
    case null:
      driveValidityFront = null;
      break;
    case '1':
      driveValidityFront = true;
      break;
    case '0':
      driveValidityFront = false;
      break;
    default:
    }

    /* end properties */

    /*stock*/
    const productStock = response.data.data.stock.stock;
    const productStockAlertThreshold = response.data.data.stock.stockAlertThreshold;
    const productLimitByCart = response.data.data.stock.limitByCart;
    const productLimitByUser = response.data.data.stock.limitByUser;

    const price = response.data.data.price.price;
    const publicPrice = response.data.data.price.publicPrice;
    const reductionType = response.data.data.price?.reductionType;
    const reductionValue = response.data.data.price?.reductionValue;
    const reductionDescription = response.data.data?.price.reductionDescription;
    const tax = response.data.data.price?.tax?.uuid;
    const purchasingPrice = response.data.data.price.purchasingPrice;

    selectedPrototype.value = response.data.data.prototype?.uuid;
    localStorage.setItem('prototype', selectedPrototype.value);
    const active = response.data.data.status.active;
    const hiddenProduct = response.data.data.status.hiddenProduct;
    let imagesData = response.data.data.images?.map((val: any) => {
      return { product_image: [{
          name: val.value,
          url: val.url,
        }],
        uuid: val.uuid
      }} )

    let descriptionListUuid =[];
    let descriptionsData = response.data.data.descriptions?.map((val: any) => {
      descriptionListUuid.push(val.uuid);
      return {
        name: val.title,
        content: val.value,
        images: [],
        position: 1,
        products: [],
        uuid: val.uuid,
      }
    });
    const dataGeolocation = response.data.data.geolocations
    const  geolocationType = dataGeolocation[0]?.typeUuid;
    let geolocationApiKey = '';
    let geolocationAddresses = [];
    if (dataGeolocation[0]?.typeValue == 'Api') {
      geolocationApiKey = dataGeolocation[0].apiKey;
    } else if (dataGeolocation[0]?.typeValue == 'Manual') {
      geolocationAddresses = dataGeolocation.map((val: any) => {
        return {
            status: val.status,
            manualMethod: val.manualMethod,  
            longitude: val.longitude,
            latitude: val.latitude,
            address: val.address,
            zipCode: val.zipCode,
            city: val.city,
            country: val.countryCode,
            formattedAddress: val.formattedAddress
        }
      });
    }

    getNode('multi-step_2').input({
      Informations : {
        productName: productName,
        reference: reference,
        adminProductName: adminProductName,
        saleClosingReason: saleClosingReason,
        urssafEvent: urssafEvent,
        socialEvent: socialEvent,
        urssafClassification: urssafClassification,
        stock: productStock, 
        stockAlertThreshold: productStockAlertThreshold,
        limitByCart: productLimitByCart,
        limitByUser: productLimitByUser,
        shortDescription: shortDescription,
        enableDate: activationDate,
        disabledDate : disabledDate,
        reductionType: reductionType,
        reductionTypeAsReduction:reductionType,
        publicPrice: publicPrice,
        price: price,
        tax: tax, 
          purchasingPrice: purchasingPrice,
        active : active,
        hiddenProduct : hiddenProduct,
        closedSale : closedSale,
        geolocationType:geolocationType,
        geolocationApiKey: geolocationApiKey,
        geolocationAddresses: geolocationAddresses,
        selectedPrototypeDefault: selectedPrototype,
        reductionValue: reductionValue,
        reductionDescription: reductionDescription,
        redirectionLink: redirectionLink,
        password: password,
        identifiant: identifiant,
        webPromoCode: webPromoCode,
        phone : phone,
        codePromoPhone : codePromoPhone,
        callPrice : callPrice,
        delayedSending : delayedSendingFront,
        usableInStore : offlineValidityFront,
        usableOnline : onlineValidityFront,
        usableInDrive : driveValidityFront

      },
      "ImagesAndDescriptions": {
        "images": imagesData? imagesData : [],
        "descriptionListUuid": descriptionListUuid? descriptionListUuid : [],
        "product_description": descriptionsData? descriptionsData : [],
      },
    });
  } catch (error) {
    console.error(error)
  }
};

onBeforeMount(async () => {
  const productUuid = route.params.uuid;
  await getProductData(productUuid);
});
</script>

<style lang="scss">
.formkit-form{
  .formkit-outer[data-type='multi-step']{
    .formkit-wrapper{
      max-width: 1200px;
      width: 100%;
      margin: auto;
      .formkit-fieldset{
        display: inline-block;
      }
    }
  }
}
</style>